import styled, { css } from 'styled-components';
import { Color } from '../../base';

const DropdownWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;

const DropdownTrigger = styled.div`
  color: ${Color.black};
  display: flex;
  align-items: center;
  button {
    border: none;
    outline: none;
    cursor: pointer;
    background: transparent;
    color: ${Color.black};
  }
`;

const DropdownCaret = styled.span`
  border: solid ${Color.greyDark};
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  width: 12px;
  height: 12px;
  vertical-align: middle;
  margin-left: 16px;
  margin-top: -8px;
  transition: all ease-in-out .4s;
  transform: rotate(45deg);
  ${props => (props.isOpen
    ? css`
          transform: rotate(-135deg);
          margin-top: 2px;
        `
    : null)}
`;

const DropdownMenu = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  position: absolute;
  min-width: 320px;
  max-width: 320px;
  padding: 16px 24px;
  margin-top: 16px;
  z-index: 1;
  border-radius: 4px;
  background-color: ${Color.white};
  border: 1px solid ${Color.greyDark};
  ${props => (props.position === 'right'
    ? css`
          right: 0;
        `
    : css`
          left: 0;
        `)};
  ${props => (props.position === 'center'
    ? css`
          left: 50%;
          transform: translateX(-50%);
        `
    : null)};
`;

export {
  DropdownWrapper, DropdownTrigger, DropdownCaret, DropdownMenu,
};
